// Liga os tipos de operação do outbox aos endpoints reais.
// Importado UMA vez no arranque (App.tsx) para que a fila possa drenar mesmo que
// o chunk da página que criou a operação ainda não tenha sido carregado.
import { registerSender, startOutbox } from '@/lib/outbox';
import { sendTap, type QueuedTap } from '@/modules/tap/tap.api';

export function initOutbox(): void {
  registerSender<QueuedTap>('tap', sendTap);
  startOutbox();
}
